// @flow
import React from 'react';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder.jsx';

type ImageInvalidProps = {
  aspectRatio: number,
  className?: string,
};

export function ImageInvalid({ aspectRatio = 0, className }: ImageInvalidProps) {
  return (
    <ImagePlaceholder aspectRatio={aspectRatio} className={className}>
      <div className="bg-gray-dark flex h-full items-center justify-center overflow-hidden p-1 text-center">
        <Icon className="opacity-25" color={COLORS.GRAY_DARKER} name={ICONS.TRIDENT1} width="4em" />
      </div>
    </ImagePlaceholder>
  );
}
